var alignmentStyle = {"alignLeft":"wBMUo","textWrapNowrap":"jB5pK","alignRight":"rprzt","alignCenter":"dRSJU","sizeFullWidth":"D-3xU","renderedInTable":"jZz5Y","sizeOriginal":"_0XL-e","sizeContent":"W95Dy","sizeSmall":"jtGxb","sizeSmallCenter":"rHQVr","flex":"D7Ybi","LEFT":"ALTWx","CENTER":"fLTK3","RIGHT":"gNVAk","AUTO":"QGv3S","JUSTIFY":"_3GuPg"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-eb707283.js.map
